import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../../../../context/installation';
import { BucketInfo, Query, SeasonPricesQueryVariables } from '../../../../../../../data-access/gql-types/graphql';
import { SEASON_PRICES } from '../../../../../../../data-access/queries/meter';
import { getHeatmapColor } from '../../../../common/tariff/utils';
import { DashboardPrice } from '../../../types/types';
import { getSeasonPricesByDate } from '../../../utils/prices';
import { DashboardTariffHours } from '../tariff-hours';

export const TauronG13SHours: React.FC = () => {
  const { skipLavvaFetch, selectedInstallationId } = useInstallationContext();
  const { data, loading } = useQuery<Query, SeasonPricesQueryVariables>(SEASON_PRICES, {
    variables: { installationId: selectedInstallationId },
    skip: skipLavvaFetch,
  });

  const g13sPrices: DashboardPrice[] = useMemo(() => {
    if (!data?.seasonPrices) return [];

    const currentHour = new Date().getHours();
    const prices = getSeasonPricesByDate(new Date().getTime(), data.seasonPrices);
    const bucketInfos = data.seasonPrices?.bucketInfos as BucketInfo[] | null;

    const dashboardPrices: DashboardPrice[] = [...prices]
      .sort((a, b) => {
        const ah = (a.startingHour - currentHour + 24) % 24;
        const bh = (b.startingHour - currentHour + 24) % 24;
        return ah - bh;
      })
      .map((x) => ({
        startingHour: x.startingHour,
        priceInkWh: x.priceInkWh,
        color: getHeatmapColor(x.priceInkWh, bucketInfos),
      }));

    return dashboardPrices;
  }, [data?.seasonPrices]);

  return <DashboardTariffHours prices={g13sPrices} loading={loading} />;
};
